@import "~@uipath/apollo-core/src/scss/base-host.scss";

$color-backrgound: var(--color-background-inverse);
$color-foreground: var(--color-foreground-inverse);

:host {
  display: block;
}

.portal-toast-container {
  display: none;
}

.portal-toast-container.portal-toast-container-open {
  background-color: $color-backrgound;
  color: $color-foreground;
  font-size: $font-m-size;
  font-family: $font-normal;
  position: absolute;
  top: 20px;
  right: 20px;
  max-width: 568px;
  min-width: 288px;
  min-height: 44px;
  box-shadow: $shadow-dp-6;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 8px;
  align-items: center;
  z-index: 3001;

  .portal-toast-body {
    display: flex;
    align-items: center;

    .portal-toast-content {
      margin: 8px;
    }

    portal-icon.portal-toast-icon-info {
      color: var(--color-info-icon);
    }

    portal-icon.portal-toast-icon-error {
      color: var(--color-error-icon);
    }

    portal-icon.portal-toast-icon-warning {
      color: var(--color-warning-icon);
    }

    portal-icon.portal-toast-icon-success {
      color: var(--color-success-icon);
    }
  }

  .actions {
    display: flex;
    align-items: center;

    .portal-toast-close {
      cursor: pointer;
    }

    .action {
      cursor: pointer;
      padding: 8px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
